import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfileRoutingModule } from './profile-routing.module';
import { CompanyInfoComponent } from './company-info/company-info.component';
import { InvoiceDetailsComponent } from './invoice-details/invoice-details.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { PersonalDataComponent } from './personal-data/personal-data.component';
import { RootAccountComponent } from './root-account/root-account.component';
import { MyTicketsComponent } from './my-tickets/my-tickets.component';
import { SharedProfileModule } from './shared/shared-profile.module';
import { EventoTicketsComponent } from './my-tickets/components/evento-tickets/evento-tickets.component';
import { SportTicketsComponent } from './my-tickets/components/sport-tickets/sport-tickets.component';
import { TransferredTicketsComponent } from './transferred-tickets/transferred-tickets.component';

@NgModule({
  declarations: [
    RootAccountComponent,
    CompanyInfoComponent,
    InvoiceDetailsComponent,
    InvoicesComponent,
    PersonalDataComponent,
    MyTicketsComponent,
    EventoTicketsComponent,
    SportTicketsComponent,
    TransferredTicketsComponent,
  ],
  imports: [CommonModule, ProfileRoutingModule, SharedProfileModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProfileModule {}
